
const Projects = [

    {
        id: 1,
        imageUrl : "https://i.ibb.co/RCBy4kk/Screenshot-from-2021-10-17-08-52-43.png",
        title : "Givemeaprotip",
        desc : "It's a open source website for learning pro-tips of technologies by the developers for the developers around the world! 🌏",
        needs : [
            {
                id : 1,
                skill : "React",
                color :"#75bcff"
            },
            {
                id : 2,
                skill : "Nodejs:Express",
                color : "#85ff75"
            },
            {
                id : 3,
                skill : "MongoDB",
                color : "#85ff75"
            }
        ],
        githubUrl : "https://github.com/Aravindakrishnan/Givemeaprotip",
        status : "Developing",
        liveUrl : "#"
    },

    {
        id : 2,
        imageUrl : "https://i.ibb.co/SnBjsLb/Screenshot-from-2021-10-17-09-21-09.png",
        title : "Cryptohashapp",
        desc : "Realtime Log of Top 100 Cryptocurrencies sparkles v0.4.0",
        needs : [
            {
                id : 1,
                skill : "React",
                color :"#75bcff"
            } 
        ],
        githubUrl : "https://github.com/Aravindakrishnan/Cryptohash-app",
        status : "live",
        liveUrl : "https://cryptohashapp.netlify.app"
    },

    {
        id : 3,
        imageUrl : "https://i.ibb.co/Dt1hxLP/Screenshot-from-2021-10-17-09-33-00.png",
        title : "Covid-19 Awareness Website",
        desc : "It's an awareness website for providing prevention info and resource for learning things during lockdown!",
        needs : [
                {
                    id : 1,
                    skill : "HTML",
                    color : "#fcae5b"
                },
                {
                    id : 2,
                    skill : "CSS",
                    color : "#5797ff"
                },
                {
                    id : 3,
                    skill : "Javascript",
                    color : "#ffec73"
                }
        ],
        githubUrl : "https://github.com/Aravindakrishnan/Covid-19-Awareness-website",
        status : "live",
        liveUrl : "https://aravindakrishnan.github.io/Covid-19-Awareness-website/prevention.html"
    }

]

export default Projects;